import React from 'react';
import { CoverBox } from 'components/atoms';

const ContainerForm: React.FC = ({ children }) => {
  return <CoverBox>{children}</CoverBox>;
};

export default ContainerForm;
